<template>
  <div style="display: flex; position: relative; left: 28px">
    <span class="title">所属单位：</span>
    <div>
      <el-select
        ref="selectPurchaseUndertakeOrgIdTree"
        style="width: 260px; display: block"
        v-model="purchaseUndertakeOrgIdValue"
        placeholder="请选择所属单位/部门"
        popper-class="popperTreeSelect"
      >
        <el-option
          :value="purchaseUndertakeOrgIdValue"
          :label="purchaseUndertakeOrgIdValue"
        >
          <el-tree
            class="my"
            ref="purchaseUndertakeOrgIdTree"
            :data="purchaseUndertakeOrgIdTreeData"
            :props="defaultProps2"
            default-expand-all
            @node-click="onPurchaseUndertakeOrgId"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <i :class="iconClass(node.data)" class="orgIcon"></i>
              <span :title="node.label">{{ node.label }}</span>
            </span>
          </el-tree>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  props: {
    purchaseUndertakeOrgIdTreeData: {
      type: Array
    },
    purchaseUndertakeOrgIdValue: {
      type: String
    }
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      defaultProps2: {
        // 经办部门经办单位
        // label: 'name',
        label: "abbrName",
        children: "child",
        name: "orgFullName",
        isLeaf: "isLeaf"
      }
    };
  },
  created() {
    console.log(this.purchaseUndertakeOrgIdTreeData, "cache");
    let data = {};
    data.deptId =
      this.purchaseUndertakeOrgIdTreeData.length > 0
        ? this.purchaseUndertakeOrgIdTreeData[0].child[0].deptId
        : "";

    data.orgDeptName = this.purchaseUndertakeOrgIdTreeData[0].child[0].orgDeptName;
    data.orgId = this.purchaseUndertakeOrgIdTreeData[0].child[0].orgId;
    Cookies.set("formCartSelect", JSON.stringify(data), {
      path: "/",
      domain: "iccec.cn"
    });
  },
  methods: {
    iconClass(i) {
      let arr = [
        "icon-ccui-organization",
        "icon-ccui-unit",
        "icon-ccui-man-hollow",
        "icon-ccui-woman-hollow"
      ];
      let keyClass = "";
      if (i.orgType === "2") {
        keyClass = arr[Number(i.orgType) + Number(i.sex) - 1];
      } else {
        keyClass = arr[i.orgType];
      }

      let obj = {};
      obj[keyClass] = true;
      return obj;
    },
    onPurchaseUndertakeOrgId(data, node, b) {
      if (data.orgType !== "0") {
        this.$parent.purchaseUndertakeOrgIdValue = data.orgDeptName;
        this.$parent.purchaseOrgId = data.orgId;
        this.$refs.selectPurchaseUndertakeOrgIdTree.blur();
        setTimeout(() => {
          this.$parent.GetQryDefault();
          //this.$parent.getQuerCartsAll();
        }, 500);
      }
      Cookies.set("formCartSelect", JSON.stringify(data), {
        path: "/",
        domain: "iccec.cn"
      });

      Cookies.remove("backCartCartData", {
        path: "/",
        domain: "iccec.cn"
      });

      Cookies.remove("backCartCartNum", {
        path: "/",
        domain: "iccec.cn"
      });
    },

    upstate() {
      this.$emit("getOrgId", {});
      setTimeout(() => {
        this.$parent.GetQryDefault();
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 13px;
  font-weight: 400;
  color: #ff142f;
  width: 67px;
}
</style>
